import { Components, formLabelClasses, Theme } from '@mui/material';

export const MuiFormLabel: Components<Theme>['MuiFormLabel'] = {
  styleOverrides: {
    root: {
      [`&.${formLabelClasses.focused}`]: {
        color: 'inherit', // prevent label from changing color when focused
      },
    },
  },
};
